
import React, { FC, Ref } from 'react';
import { selectTournament } from '../../../../../features/tournament/tournamentSelectors';

import { useAppSelector } from '../../../../../hooks/redux';
import { User } from '../../../../../types/tournament';
import { IMatch } from '../PlayTag/PlayTag';
import { TournamentPrintCardTeam } from '../TournamentPrintCardTeam';
import { getPlayerName } from './TournamentPrintCard.helpers';
import { TournamentCardHeadSection } from '../TournamentCardHeadSection';

import './TournamentPrintCard.scss';

interface TournamentPrintCardProps {
    ref: Ref<any>;
    matches: IMatch[];
}

export const TournamentPrintCard: FC<TournamentPrintCardProps> = React.forwardRef(({ matches }, ref) => {
    const { courts } = useAppSelector(selectTournament).data || {};

    return (<div ref={ref} className="tournament-print-card">
        {matches.map((match, index) => {
            const { name: courtName } = courts?.find(({ id }) => id === match.court) || { name: '' };
            return (
                <div key={match.id} className={"tournament-print-card__match" + ((index % 2 === 1 || index === matches.length - 1) ? ' tournament-print-card__match_last' : '')}>
                    <TournamentCardHeadSection
                        matchId={match.matchId}
                        court={courtName}
                        startDate={match.startDate}
                        scheduleDate={match.scheduleDate}
                    />
                    <div className="tournament-print-card__home-team">
                        <TournamentPrintCardTeam
                            matchId={match.matchId}
                            court={courtName}
                            team={1}
                            player1={getPlayerName(match.homePlayer1 || {} as User)}
                            player2={getPlayerName(match.homePlayer2 || {} as User)}
                        />
                    </div>
                    <div className="tournament-print-card__away-team">
                        <TournamentPrintCardTeam
                            matchId={match.matchId}
                            court={courtName}
                            team={2}
                            player1={getPlayerName(match.awayPlayer1 || {} as User)}
                            player2={getPlayerName(match.awayPlayer2 || {} as User)}
                        />
                    </div>
                </div>
            )
        })}
    </div>)
});